import {
  Button,
  InputFile,
  Form,
  ModalFooter,
} from "@telluscompany/design-system";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { createDocumentSchema, DocumentUploadFormData } from "../../schemas";
import { useLocalization } from "@i18n";

interface UploadDocumentModalProps {
  onSubmit: (data: DocumentUploadFormData) => void;
  onCancel: () => void;
}

export const UploadDocumentModal = ({
  onSubmit,
  onCancel,
}: UploadDocumentModalProps) => {
  const { translate } = useLocalization();

  const form = useForm<DocumentUploadFormData>({
    resolver: zodResolver(createDocumentSchema(translate)),
  });

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <div className="px-[32px] py-[16px]">
          <InputFile
            control={form.control}
            label={translate("management.termsOfUse.form.label.file")}
            name="file"
            maxFiles={1}
          />
        </div>
        <ModalFooter
          footer={
            <Button type="submit" variant="primary">
              {translate("management.termsOfUse.button.save")}
            </Button>
          }
          closeModal={
            <Button type="button" variant="secondary" onClick={onCancel}>
              {translate("management.termsOfUse.button.cancel")}
            </Button>
          }
        />
      </form>
    </Form>
  );
};
